import React, { useState } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";

function SideBarAdmin({ widthWindow, screen }: any) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const items = [
    { key: "home", label: "Accueil", icon: "bx bx-home", path: "/dashboard-admin" },
    { key: "categories", label: "Categories", icon: "bx bx-category", path: "/dashboard-admin/categories" },
    { key: "subCategories", label: "SubCategories", icon: "bx bx-list-ul", path: "/dashboard-admin/subCategories" },
    { key: "products", label: "Products", icon: "bx bx-store", path: "/dashboard-admin/products" },
    { key: "packages", label: "Packages", icon: "bx bx-package", path: "/dashboard-admin/packages" },
    { key: "orders", label: "Orders", icon: "bx bx-cart", path: "/dashboard-admin/orders" },
        { key: "users", label: "Users", icon: "bx bx-user", path: "/dashboard-admin/users" },

  ];

  const goTo = (path: string) => {
    navigate(path);
    if (widthWindow <= 900) setIsOpen(false);
  };

  const SidebarContent = () => (
    <div className="side-bar-content">
      <div className="sidebar-brand">
        <div className="logo-circle">A</div>
        <div className="brand-text">
          <span className="brand-title">Admin</span>
          <span className="brand-sub">Dashboard</span>
        </div>
      </div>

      <div className="buttons-container">
        {items.map((item) => (
          <button
            key={item.key}
            className={screen === item.key ? "btn-dash-active" : "btn-dash"}
            onClick={() => goTo(item.path)}
          >
            <div className="btn-left">
              <i className={item.icon} />
              <span>{item.label}</span>
            </div>

            <i className="bx bx-chevron-right arrow" />
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {widthWindow > 900 ? (
        <SidebarContent />
      ) : (
        <>
          <div className="menu-close" onClick={() => setIsOpen(!isOpen)}>
            <span>Menu</span>
            <i className={`bx ${isOpen ? "bx-x" : "bx-menu"}`} style={{ fontSize: 24 }} />
          </div>

          {isOpen && (
            <div className="mobile-sidebar-wrapper">
              <SidebarContent />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default SideBarAdmin;
